module.exports = __webpack_public_path__ + "media/images/cards/cc-apple-pay-d19e20a5e6e70c5c497dcdf5b50633d8.svg";